import { Head, Link, useForm } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { passwords, sessions } from '@/routes'

export default function Login() {
  const form = useForm({ email_address: '', password: '' })

  return (
    <Card>
      <Head title="Sign in" />
      <CardHeader>
        <CardTitle>Sign in</CardTitle>
      </CardHeader>
      <CardContent>
        <form
          className="grid gap-4"
          onSubmit={(e) => {
            e.preventDefault()
            form.submit(sessions.create())
          }}
        >
          <div className="grid gap-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              autoComplete="username"
              value={form.data.email_address}
              onChange={(e) => form.setData('email_address', e.target.value)}
              required
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              value={form.data.password}
              onChange={(e) => form.setData('password', e.target.value)}
              required
            />
          </div>
          <Button type="submit" disabled={form.processing}>
            {form.processing ? 'Signing in…' : 'Sign in'}
          </Button>
          <Link href={passwords.new()} className="text-center text-sm text-muted-foreground underline">
            Forgot password?
          </Link>
        </form>
      </CardContent>
    </Card>
  )
}
